/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pxk_Items_ErrorInputs */

const vi_orders_pxk_items_error = /** @type {(inputs: Orders_Pxk_Items_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách hàng của phiếu xuất kho. Bấm vào thẻ để mở phiếu xem chi tiết.`)
};

/**

* @param {Orders_Pxk_Items_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_items_error = /** @type {((inputs?: Orders_Pxk_Items_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Items_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_items_error(inputs)
});